import React from 'react';
import Component from '../../components/Component'
import Team from '../../models/Team';
import InfoTooltip from "../../components/InfoTooltip";
import LoadingSpinner from "../../components/LoadingSpinner";
import Form from "../../components/form/Form";
import { Collapse as ANTCollapse, Tooltip } from "antd";
import EmptyBanner from "../../components/EmptyBanner";
import TalentCandidate from "../../models/TalentCandidate";

export default class AddToProjectModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            search: '',
            isLoading: false,
            isInviting: false,
        };
    }

    async viewAllActive() {
        await this.setState({ isLoading: true, search: '', projects: null });

        await TB.wait(500);

        await this.searchProjects('')
    }

    async searchProjects(search) {
        await this.promisedState({ error: null, isLoading: true, projects: null, search });

        let projects = await this.props.talent.searchProjectsForClient(
            search
        );

        projects = TB.orderBy(projects, [
            (project => project.positions.filter(pos => pos.can_invite)),
            'can_invite'
        ], ['desc', 'desc'])

        await this.promisedState({ isLoading: false, projects });
    }

    async inviteTalentToWorkOn(project, position) {
        await this.promisedState({ isInviting: true });

        let {
            talent,
        } = this.props;

        let result;


        if (talent instanceof TalentCandidate) {
            talent = TalentCandidate.make({ ...talent });
            result = await talent.addToCandidates(
                project, position
            )
        } else if (talent instanceof Team) {
            result = await talent.requestProposalFor(
                project
            )

        }
        if (result) {
            return this.props.onInviteSent();
        } else {
            this.promisedState({ isInviting: false, error: 'Something went wrong. Please try again later.' })
        }
    }

    render() {
        let {
            isLoading, error, projects = [],
            isInviting,
        } = this.state;

        return (
            <>
                {!error && (
                    <div className="flex flex-col items-stretch">
                        <Form
                            model={this.state}
                            className="default-form invite-to-project-form"
                            onChange={model => this.searchProjects(model.search)}
                            submitButton={false}
                            fields={{
                                search: {
                                    required: false,
                                    placeholder: 'Search by project name',
                                    disabled: isInviting,
                                    label: `Choose a project below to get a proposal from this ${true ? 'individual' : 'team'}.`
                                },
                                viewActive: {
                                    component: (
                                        <div className="my-2">
                                            <button
                                                disabled={isLoading || isInviting}
                                                onClick={() => this.viewAllActive()}
                                                className="btn btn-link btn-link-primary text-uppercase">
                                                View all Active projects
                                            </button>
                                        </div>
                                    )
                                }
                            }}
                        />

                        {projects && (projects?.length > 0 ? (
                            <ANTCollapse accordion bordered={false} className="bg-transparent">
                                {projects.map(project => this.renderInviteRow2(project))}
                            </ANTCollapse>
                        ) : (
                            <EmptyBanner icon="fas fa-clipboard fa-4x" message="No matches found, try editing you search or click above to view all active projects." />
                        ))}

                        {/* {projects && (projects.length > 0 ? projects.map(project => this.renderInviteRow(project)) : (
                            <EmptyBanner icon="fas fa-clipboard fa-4x"
                                message="No matches found, try editing you search or click above to view all active projects." />
                        ))} */}
                    </div>
                )}

                {(isLoading || isInviting) && (
                    <div
                        className="pt-5 flex flex-col self-stretch items-center justify-center">
                        <LoadingSpinner size="lg" />
                    </div>
                )}


                {!isInviting && !isLoading && error && (
                    <div className="invite-error">

                        <i className="fas fa-exclamation-circle fa-4x mb-3" />

                        <h4>Can't Send Invite for Position</h4>
                        <p>{error}</p>

                        <button className="btn btn-dark" onClick={async () => {
                            await this.promisedState({ isLoading: true });

                            await this.promisedState({ search: '', selectedInvite: null, error: null });

                            await TB.wait(300);

                            await this.promisedState({ isLoading: false })
                        }}>
                            Try another role
                        </button>

                    </div>
                )}

            </>
        );
    }

    renderInviteRow2(project) {
        const isUnavailable = !project.positions?.length && !project.can_invite;

        return (
            <ANTCollapse.Panel
                key={`invite-${project.id}`}
                collapsible={isUnavailable && 'disabled'}
                header={(
                    <div className="flex items-center justify-between">
                        <p className="text-bold">{project.name}</p>

                        {project.can_invite && (
                            <button
                                onClick={() => this.inviteTalentToWorkOn(project)}
                                disabled={this.state.isInviting}
                                className="btn btn-link btn-link-primary"
                            >
                                Send Invite
                            </button>
                        )}

                        {isUnavailable && (
                            <div className="disabled-edit-link">
                                <p className="mb-0">
                                    <Tooltip
                                        placement="top"
                                        color="#000"
                                        title={project.invite_restriction || 'Project Unavailable'}
                                    >
                                        <span className="mr-2">Unavailable</span>
                                        <i className="fa fa-info-circle" />
                                    </Tooltip>
                                </p>
                            </div>
                        )}
                    </div>
                )}
            >
                {project.positions && (
                    <div>
                        {/* <p className="mb-2">Project Roles</p> */}
                        <table className="table table-responsive table-light">
                            <thead>
                                <tr>
                                    <th className="text-left border-b border-[#e5e5e5]">Role</th>
                                    <th className="border-b border-[#e5e5e5]" />
                                </tr>
                            </thead>
                            <tbody>
                                {project.positions.map(position => (
                                    <tr key={position.id + '-' + project.id}>
                                        <td>
                                            {position.title}
                                        </td>

                                        <td className="invite-action">

                                            {position.can_invite ? (
                                                <button
                                                    onClick={() => this.inviteTalentToWorkOn(project, position)}
                                                    disabled={this.state.isInviting}
                                                    className="btn btn-link btn-link-primary"
                                                >
                                                    Send Invite
                                                </button>
                                            ) : (
                                                <div className="disabled-edit-link">
                                                    <p className="mb-0">
                                                        <Tooltip
                                                            placement="top"
                                                            color="#000"
                                                            title={position.invite_restriction}
                                                        >
                                                            <span className="mr-2">Unavailable</span>
                                                            <i className="fa fa-info-circle" />
                                                        </Tooltip>
                                                    </p>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </ANTCollapse.Panel>
        )
    }

    // renderInviteRow(project) {
    //     let key = `invite-${project.id}`;

    //     return (
    //         <div className="project-invite-row" key={key}>
    //             <div className="project-row mb-1">
    //                 <div><b>{project.name}</b></div>
    //                 {project.positions?.length ? (
    //                     <button onClick={() => {
    //                         let projectDetailOpened = key;
    //                         if (this.state.projectDetailOpened === projectDetailOpened) {
    //                             projectDetailOpened = null;
    //                         }
    //                         this.setState({ projectDetailOpened })
    //                     }} className="btn btn-link btn-link-primary mx-3">
    //                         {this.state.projectDetailOpened === key ? "Close" : "Select from project roles"}
    //                     </button>
    //                 ) : (
    //                     project.can_invite ? (
    //                         <button
    //                             onClick={() => this.inviteTalentToWorkOn(project)}
    //                             disabled={this.state.isInviting}
    //                             className="btn btn-link btn-link-primary">
    //                             Send Invite
    //                         </button>
    //                     ) : (
    //                         <div className="disabled-edit-link">
    //                             <p className="mb-0">
    //                                 <span className="mr-2">Unavailable</span>
    //                                 <InfoTooltip placement="top" type="danger">
    //                                     {project.invite_restriction}
    //                                 </InfoTooltip>
    //                             </p>
    //                         </div>

    //                     )
    //                 )}
    //             </div>
    //             {project.positions && (
    //                 <Collapse isOpen={this.state.projectDetailOpened === key}>
    //                     <div>
    //                         <table className="table table-responsive table-light">

    //                             <thead>
    //                                 <tr>
    //                                     <th>Role</th>
    //                                     <th />
    //                                 </tr>
    //                             </thead>
    //                             <tbody>
    //                                 {project.positions.map(position => (
    //                                     <tr key={position.id + '-' + project.id}>
    //                                         <td>
    //                                             {position.title}
    //                                         </td>

    //                                         <td className="invite-action">

    //                                             {position.can_invite ? (
    //                                                 <button
    //                                                     onClick={() => this.inviteTalentToWorkOn(project, position)}
    //                                                     disabled={this.state.isInviting}
    //                                                     className="btn btn-link btn-link-primary">
    //                                                     Send Invite
    //                                                 </button>
    //                                             ) : (
    //                                                 <div className="disabled-edit-link">
    //                                                     <p className="mb-0">
    //                                                         <span className="mr-2">Unavailable</span>
    //                                                         <InfoTooltip placement="top" type="danger">
    //                                                             {position.invite_restriction}
    //                                                         </InfoTooltip>
    //                                                     </p>
    //                                                 </div>

    //                                             )}
    //                                         </td>
    //                                     </tr>
    //                                 ))}
    //                             </tbody>
    //                         </table>
    //                     </div>
    //                 </Collapse>
    //             )}
    //         </div>
    //     )
    // }
}